@for (i of slots; track i) {
  @if (photos[i]) {
    <div #slot class="reel-slot-filled">
      <img class="reel-thumbnail" [src]="photos[i].dataUrl" (click)="inspect.emit(i)" />
      <cs-icon-button class="remove-button" icon="close" xx-small danger (click)="onRemoveClick($event, i)"></cs-icon-button>
    </div>
  } @else {
    <div #slot class="reel-slot-empty" [class.clickable]="canAdd" (click)="onEmptySlotClick()"></div>
  }
}
